export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8114.ec5bbdc2.jpg";